import Parse from "parse";















export class Attachment extends Parse.Object {
  constructor(data) {
    super("APP_Attachment", data );
  }
}

Parse.Object.registerSubclass("APP_Attachment", Attachment);
